import React from "react";
import { FaShareAlt, FaTimes } from "react-icons/fa";

export default function ProductsToolbar({
  ui,
  onChange,
  debouncedQ,
  setDebouncedQ,
  onReset,
  onShare,
  shareCopied,
}) {
  return (
    <div className="flex flex-col gap-3">
      {/* ligne 1: recherche + icônes actions */}
      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        <input
          type="text"
          placeholder="Rechercher (nom, description)…"
          className="input input-bordered w-full dark:bg-slate-200 dark:text-black"
          value={debouncedQ}
          onChange={(e) => setDebouncedQ(e.target.value)}
        />

        <div className="flex items-center gap-2">
          {/* partager */}
          <button
            type="button"
            onClick={onShare}
            title={shareCopied ? "Lien copié !" : "Copier un lien partageable"}
            aria-label="Partager"
            className={`w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              ${
                shareCopied
                  ? "bg-emerald-50 ring-emerald-200 text-emerald-600 dark:bg-emerald-900/20 dark:ring-emerald-800"
                  : "bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
              }`}
          >
            <FaShareAlt className={`text-lg ${shareCopied ? "animate-pulse" : ""}`} />
          </button>

          {/* reset */}
          <button
            type="button"
            onClick={onReset}
            title="Réinitialiser"
            aria-label="Reset filtres"
            className="w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
      </div>

      {/* ligne 2: tri */}
      {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <div className="md:col-span-3" />
        <select
          className="select select-bordered w-full dark:bg-slate-200 dark:text-black"
          value={ui.sort}
          onChange={(e) => onChange({ sort: e.target.value })}
        >
          <option value="order">Tri par ordre d’affichage</option>
          <option value="alpha">Tri alphabétique</option>
        </select>
      </div> */}
    </div>
  );
}
